<template>
	<span>
		<span v-if="showNav">
			<a
				data-cy="side-e-sim-collapse"
				:aria-expanded="eSimCollapse"
				class="sidebar-menu-item nav-link"
				data-toggle="collapse"
				@click="eSimCollapse = !eSimCollapse"
			>
				<template>
					<i class="fa pr-2 fa-sim-card text-green"></i>
					<span class="nav-link-text">eSim <b class="caret"></b></span>
				</template>
			</a>
			<collapse-transition :duration="{enter: 500, leave: 500}">
				<div
					v-show="eSimCollapse"
					id="collapse-just1"
					:class="eSimCollapse ? 'show' : ''"
					class="collapse collapse-just"
				>
					<ul class="nav nav-sm flex-column">
						<slot v-for="(item, index) in links" name="title">
							<router-link
								:key="index"
								:data-cy="getCypressDataCy(item.link)"
								:target="item.link"
								class="nav-link"
								:href="item.link"
								:to="item.link"
								@click.native="linkClick"
								:title="item.description"
								b-v-tooltip.hover
							>
								<template>
									<i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
									<span class="nav-link-text">{{ item.name }}</span>
								</template>
							</router-link>
						</slot>
					</ul>
				</div>
			</collapse-transition>
		</span>
	</span>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";

export default {
	name: "side-e-sim-dynamic-group",
	components: {
		CollapseTransition,
	},
	data() {
		return {
			eSimCollapse: false,
		};
	},
	computed: {
		links() {
		return this.$store.getters["getLinksByGroup"]('eSim')
		},
		showNav() {
		return this.$store.getters["getLinksByGroup"]('eSim').length > 0
		},
	},
	methods: {

		linkClick() {
			if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
				this.$sidebar.displaySidebar(false);
			}
		},
    getCypressDataCy(route) {
      let arr = route.split('/');
      let formattedRoute = arr[arr.length - 1];
      if (formattedRoute.includes(':')) {
        formattedRoute = arr[arr.length - 2];
      }
      // console.log(formattedRoute)
      return `side-e-sim-${formattedRoute}`;
    },
	},
};
</script>
